export default __webpack_public_path__ + "static/meghan-baeb6a05f9bae46b8c8d957929ce0a72.png";